module.exports = __webpack_public_path__ + "static/img/home_fiveScene_fifthIllustration_img.b931046.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_fiveScene_fifthIllustration_img.png
// module id = HZrI
// module chunks = 0